import { Lock } from 'lucide-react';

interface FeatureDisabledProps {
  featureName: string;
  description?: string;
}

export function FeatureDisabled({ featureName, description }: FeatureDisabledProps) {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="text-center px-6">
        <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Lock className="w-8 h-8 text-white/50" />
        </div>
        <h2 className="text-lg font-semibold text-white mb-2">{featureName} nicht verfügbar</h2>
        <p className="text-white/70 max-w-sm">
          {description || 'Diese Funktion ist derzeit deaktiviert. Bitte versuche es später erneut.'}
        </p>
      </div>
    </div>
  );
}
